function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // cookie expiration in days
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function getCookie(name) {
  const nameEQ = name + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookiesArr = decodedCookie.split(';');
  for (let i = 0; i < cookiesArr.length; i++) {
    let cookie = cookiesArr[i].trim();
    if (cookie.indexOf(nameEQ) == 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

function deleteCookie(name) {
  setCookie(name, '', -1);
}

export { setCookie, getCookie, deleteCookie };
